import type { Theme } from '@mui/material';
import { Skeleton } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';

const skeletonStyles = (theme: Theme) => ({
  width: '100%',
  height: '10rem',
  transformOrigin: 'center',
  backgroundColor: theme.palette.baseColors.iceBlue.c50,
});

type ReportSkeletonProps = ComponentProps<typeof Skeleton>;

const ReportSkeleton = ({ sx, ...props }: ReportSkeletonProps) => {
  return (
    <Skeleton
      variant='rectangular'
      sx={combineSx(skeletonStyles, sx)}
      data-id='asset-report-skeleton'
      {...props}
    />
  );
};

export { ReportSkeleton };
